import React, {Component} from 'react';

class IllustrationIcon extends Component {
    render() {
        return (
            <svg className={this.props.className} viewBox="0 0 425 425" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="background"
                      d="M212.2 424.4C329.395 424.4 424.4 329.395 424.4 212.2C424.4 95.0052 329.395 0 212.2 0C95.0052 0 0 95.0052 0 212.2C0 329.395 95.0052 424.4 212.2 424.4Z"
                      fill="#ED5149"/>
                <g className="pencil">
                    <path
                        d="M288.6 130.5L301.2 143.2L306.3 148.3L320.1 134.6C324.2 130.5 324.3 123.7 320.2 119.6L312.5 111.9L312.2 111.5C308.1 107.4 301.3 107.3 297.2 111.4L283.4 125.1L288.6 130.5Z"
                        fill="#B32625"/>
                    <path d="M301.1 143.1L301.2 143.2L288.6 130.5L148.4 268.8L143.7 285.9L161.2 281.1L301.1 143.1Z"
                          fill="#FFC912"/>
                    <path d="M148.5 268.7L148.4 268.8L288.6 130.5L283.4 125.2L283.3 125.1L132 274.3L148.5 268.7Z"
                          fill="#FFDF71"/>
                    <path d="M301.1 143.1L161.2 281.1L155.2 297.7L306.5 148.5L306.3 148.3L301.2 143.2L301.1 143.1Z"
                          fill="#F0B243"/>
                    <path
                        d="M121.2 308.6L143.7 285.9L147.2 284.9L161.2 281L155.3 297.6L161.2 281.1V281L143.7 285.8L148.5 268.7L132.1 274.2L118.6 299.8C119.9 302.9 120.7 305.9 121.2 308.6Z"
                        fill="#EEE0D6"/>
                    <path
                        d="M161.2 281.1L147.2 285L143.7 286L121.2 308.7C121.6 311 121.7 313.2 121.7 315.1L155.2 297.8L161.2 281.1Z"
                        fill="#F2D1A1"/>
                    <path
                        d="M121.7 315C121.7 313.1 121.6 311 121.2 308.6C120.7 305.8 119.9 302.9 118.6 299.9L108.1 319.8C107.6 320.7 108.6 321.8 109.6 321.3L115.5 318.3L121.7 315Z"
                        fill="#B32625"/>
                </g>
                <g className="stars">
                    <g className="star">
                        <path className="star"
                              d="M120.2 175.7L136.2 184.4L120.2 193.1L111.5 209L102.8 193.1L86.8999 184.4L102.8 175.7L111.5 159.8L120.2 175.7Z"
                              fill="#FFFFFF"/>
                    </g>

                    <g className="star">
                        <path className="star"
                              d="M289.7 243.4L305.3 251.9L289.7 260.5L281.2 276L272.7 260.5L257.1 251.9L272.7 243.4L281.2 227.9L289.7 243.4Z"
                              fill="#FFFFFF"/>
                    </g>

                    <g className="star">
                        <path className="star"
                              d="M243.8 111.1L253.5 116.4L243.8 121.7L238.5 131.4L233.2 121.7L223.5 116.4L233.2 111.1L238.5 101.4L243.8 111.1Z"
                              fill="#FFFFFF"/>
                    </g>

                </g>
                <path
                    d="M327.9 197.3C326.6 197.3 325.6 196.3 325.6 195V181.4C325.6 180.1 326.6 179.1 327.9 179.1C329.2 179.1 330.2 180.1 330.2 181.4V195C330.2 196.3 329.2 197.3 327.9 197.3Z"
                    fill="#EFE1D7"/>
                <path
                    d="M334.7 190.5H321.1C319.8 190.5 318.8 189.5 318.8 188.2C318.8 186.9 319.8 185.9 321.1 185.9H334.7C336 185.9 337 186.9 337 188.2C337 189.5 336 190.5 334.7 190.5Z"
                    fill="#EFE1D7"/>
                <path
                    d="M228.9 346.3C227.6 346.3 226.6 345.3 226.6 344V330.4C226.6 329.1 227.6 328.1 228.9 328.1C230.2 328.1 231.2 329.1 231.2 330.4V344C231.2 345.3 230.2 346.3 228.9 346.3Z"
                    fill="#EFE1D7"/>
                <path
                    d="M235.7 339.5H222.1C220.8 339.5 219.8 338.5 219.8 337.2C219.8 335.9 220.8 334.9 222.1 334.9H235.7C237 334.9 238 335.9 238 337.2C238 338.5 237 339.5 235.7 339.5Z"
                    fill="#EFE1D7"/>
                <path
                    d="M98.8996 266.3C97.5996 266.3 96.5996 265.3 96.5996 264V250.4C96.5996 249.1 97.5996 248.1 98.8996 248.1C100.2 248.1 101.2 249.1 101.2 250.4V264C101.2 265.3 100.2 266.3 98.8996 266.3Z"
                    fill="#EFE1D7"/>
                <path
                    d="M105.7 259.5H92.0998C90.7998 259.5 89.7998 258.5 89.7998 257.2C89.7998 255.9 90.7998 254.9 92.0998 254.9H105.7C107 254.9 108 255.9 108 257.2C108 258.5 107 259.5 105.7 259.5Z"
                    fill="#EFE1D7"/>
                <path
                    d="M155.9 139.3C154.6 139.3 153.6 138.3 153.6 137V123.4C153.6 122.1 154.6 121.1 155.9 121.1C157.2 121.1 158.2 122.1 158.2 123.4V137C158.2 138.3 157.2 139.3 155.9 139.3Z"
                    fill="#EFE1D7"/>
                <path
                    d="M162.7 132.5H149.1C147.8 132.5 146.8 131.5 146.8 130.2C146.8 128.9 147.8 127.9 149.1 127.9H162.7C164 127.9 165 128.9 165 130.2C165 131.5 164 132.5 162.7 132.5Z"
                    fill="#EFE1D7"/>
                <path
                    d="M219.2 286.5C221.133 286.5 222.7 284.933 222.7 283C222.7 281.067 221.133 279.5 219.2 279.5C217.267 279.5 215.7 281.067 215.7 283C215.7 284.933 217.267 286.5 219.2 286.5Z"
                    fill="#EFE1D7"/>
                <path
                    d="M192.2 163.5C194.133 163.5 195.7 161.933 195.7 160C195.7 158.067 194.133 156.5 192.2 156.5C190.267 156.5 188.7 158.067 188.7 160C188.7 161.933 190.267 163.5 192.2 163.5Z"
                    fill="#EFE1D7"/>
                <path
                    d="M328.2 228.5C330.133 228.5 331.7 226.933 331.7 225C331.7 223.067 330.133 221.5 328.2 221.5C326.267 221.5 324.7 223.067 324.7 225C324.7 226.933 326.267 228.5 328.2 228.5Z"
                    fill="#EFE1D7"/>
                <path
                    d="M162.2 212.5C164.133 212.5 165.7 210.933 165.7 209C165.7 207.067 164.133 205.5 162.2 205.5C160.267 205.5 158.7 207.067 158.7 209C158.7 210.933 160.267 212.5 162.2 212.5Z"
                    fill="#EFE1D7"/>
                <path
                    d="M291.2 310.5C293.133 310.5 294.7 308.933 294.7 307C294.7 305.067 293.133 303.5 291.2 303.5C289.267 303.5 287.7 305.067 287.7 307C287.7 308.933 289.267 310.5 291.2 310.5Z"
                    fill="#EFE1D7"/>
                <path
                    d="M159.2 329.5C161.133 329.5 162.7 327.933 162.7 326C162.7 324.067 161.133 322.5 159.2 322.5C157.267 322.5 155.7 324.067 155.7 326C155.7 327.933 157.267 329.5 159.2 329.5Z"
                    fill="#EFE1D7"/>
            </svg>

        );
    }
}

export default IllustrationIcon;